import { bootstrapApplication } from "@angular/platform-browser";
import { App } from "./app/app";
import { appConfig } from "./app/app.config";
import { environment } from "./environments/environment";

declare global {
    interface Window {
        dataLayer: unknown[];
        gtag: (...args: unknown[]) => void;
    }
}

function initializeAnalytics(measurementId: string) {
    if (!measurementId) {
        return;
    }

    if (!document.getElementById("ga-gtag")) {
        const script = document.createElement("script");
        script.id = "ga-gtag";
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
        document.head.appendChild(script);
    }

    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
        // eslint-disable-next-line prefer-rest-params
        window.dataLayer.push(arguments as any);
    };
    window.gtag("js", new Date());
    window.gtag("config", measurementId, { send_page_view: false });
}

initializeAnalytics(environment.GA);

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
